export interface IDashDonorShield {
      id: number,
      surgeryDate: string,
      organType: number,
      donorEmail: string,
      donorAbo: number,
      donorGender: number,
      donorName: string,
      donorAddress1: string,
      donorCity: string,
      donorState: number,
      donorPostal: string,
      donorPhone: string,
      donorBirthDate: string
}
